import React, { useEffect, useState } from "react";
import PageHeader from "../common/components/PageHeader";
import { Box, Stack, Typography } from "@mui/material";
import CommonCard from "../common/components/CommonCard";
import { FiberManualRecord } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../features/authSlice";
import { showNotification } from "../common/components/Notification/ToastifyNotification";
import { getStaticPage } from "../api/staticPageApi";
import { StaticPageType } from "../common/const";
import LoadingSpinner from "../common/components/LoadingSpinner";
import theme from "../theme";

const TermCondition = () => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.auth);
    const [content, setContent] = useState(null);

    const getPage = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getStaticPage(StaticPageType.TERMS);
            const { content_html } = response?.data;
            setContent(content_html)
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            if (errorMessage !== 'Static Page not found') {
                showNotification(errorMessage, 'error');
            }
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getPage();
    }, []);

    return (
        <Box sx={{ p: 4 }}>
            {loading && (
                <LoadingSpinner />
            )}
            <PageHeader
                title="My DCP Terms & Conditions"
                content={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.secondary" sx={{ fontSize: 14 }}>
                            Account
                        </Typography>
                        <FiberManualRecord sx={{ fontSize: 8, color: 'text.secondary' }} />
                        <Typography color="text.secondary" sx={{ fontSize: 14 }}>
                            My DCP Terms & Conditions
                        </Typography>
                    </Stack>
                }
            />
            <CommonCard
                content={
                    <Box>
                        {content ? (
                            <Typography
                                textAlign="justify"
                                component="div"
                                dangerouslySetInnerHTML={{ __html: content }}
                            />
                        ) : (
                            <Typography
                                textAlign="center"
                                color={theme.palette.background.dark}
                            >
                                No Data Found
                            </Typography>
                        )}
                    </Box>
                }
            />
        </Box>
    )
}

export default TermCondition;